<template>
  <vuex-table :fields="fields" table_store="pbx/numbers/table">
    <template slot="type" slot-scope="{ item }">
      {{ $tc(`pbx.number.type.${item.type}`, 1) }}
    </template>

    <template slot="type_use" slot-scope="{ item }">
      {{ $t(`pbx.number.type_use.${item.used ? 'use' : 'not_use'}`) }}
    </template>

    <template slot="login" slot-scope="{ item }">
      {{ item.sip_account ? item.sip_account.login : '' }}
    </template>

    <template slot="actions" slot-scope="{ item }">
      <template v-if="item.used">
        <tooltip
          :content="$t('pbx.number.modal.remove.disabled')"
          theme="light"
          placement="bottom-end"
          max-width="350px"
          class="text-left"
        >
          <table-control type="trash" :disabled="true" />
        </tooltip>
      </template>
      <template v-else>
        <table-control type="trash" :disabled="item.used" @click="remove_item(item)" />
      </template>
    </template>
  </vuex-table>
</template>

<script>
  import { NumberModalService } from '@pbx/modals/NumberModalService';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      fields: function() {
        return [
          { key: 'number', label: this.$t('pbx.number.field.number'), sortable: true },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true
          },
          { key: 'type', label: this.$t('pbx.number.field.type'), sortable: true },
          { key: 'type_use', label: this.$t('pbx.number.field.type_use'), sortable: false },
          { key: 'login', label: this.$t('pbx.number.field.login'), sortable: false },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/numbers/table', ['getAsyncData']),
      remove_item: function(item) {
        NumberModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
